import { render } from "./PaymentFailIcon.vue?vue&type=template&id=e584e91e"
import script from "./PaymentFailIcon.vue?vue&type=script&lang=js"
export * from "./PaymentFailIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__